import { useSelector } from "react-redux";

export function useHooks() {
    const getSearchValue = useSelector(
        (state: any) => state.APIResponse.searchValue
    );
    const getSpaceList = useSelector(
        (state: any) => state.APIResponse.spaceList
    );
    const getMySpaceList = useSelector(
        (state: any) => state.APIResponse.mySpace
    );
    const getOpenInfoModal = useSelector(
        (state: any) => state.APIResponse.isOpenModal
    );

    return {
        getSearchValue,
        getSpaceList,
        getMySpaceList,
        getOpenInfoModal
    }
}